// 初回の名前入力に最初から入れておく名前の候補（ランダムに1つ。プレイヤーは書き換えられる・引き直せる）。
// キャラ・妖・式神・看板娘の名前と同じものは入れない（プレイヤーとキャラを取り違えないように）。足す・消す・入れ替えるのは自由（2〜12文字、記号 <>&"'` と不適切な言葉は使えない：apps/worker/src/text.ts の checkName）。
export const RANDOM_NAMES: readonly string[] = [
  '月影', '鬼火丸', '夜叉丸', '朧月', '狐火', '白狐', '黒狐', '天狗丸', '風切', '雪見',
  '霧丸', '灯守', '宵闇', '百鬼丸', '影法師', '朝顔', '夕顔', '木枯らし', '金棒', '銀杏',
  '紅葉', '桔梗', '寒椿', '牡丹', '山吹', '藤丸', '菖蒲', '若竹', '松風', '竹取',
  '花火師', '提灯持ち', '旅の陰陽師', '野良侍', '流れ忍', '見習い神主', '鍛冶見習い', '茶屋の看板娘', '団子屋', '飴売り',
  '春雷', '一つ目', '傘おばけ', '鬼灯', 'かまいたち', 'ろくろ首', 'のっぺら', '河童の皿', '座敷童', 'あまのじゃく',
  '朝霧', '夕凪', '夜風', '星読み', '月見団子', '雷丸', '稲妻', '火の玉', '水鏡', '石灯籠',
  '鈴音', '笛吹き', '太鼓持ち', '琵琶法師', '三味線', '草笛', '鳴子', '風鈴', '鬼瓦', '招き猫',
  '城攻め好き', '陣取り名人', '櫓の上', '幟持ち', '兵糧番', '早駆け', '一番槍', '殿様', '軍師見習い', '足軽頭',
  '狐の嫁入り', '百鬼夜行', '丑三つ時', '逢魔が時', '黄昏', '宵の明星', '有明', '暁月', '東雲', '十六夜',
  '梅鉢', 'ちよ', 'はやて', 'すずめ', 'つばめ', 'たぬき', 'こたろう', 'さくら', 'ぽんた', 'もみじ',
];

/** 候補からランダムに1つ（except と同じものは避ける） */
export function randomName(except?: string): string {
  const pool = RANDOM_NAMES.filter((n) => n !== except);
  return pool[Math.floor(Math.random() * pool.length)] ?? RANDOM_NAMES[0];
}
